import React from 'react';
import FutureDateRangePicker from 'components/DateRangePicker/FutureDateRangePicker';
import moment from 'moment';
import { FormikErrors } from 'formik';
import { Form } from 'rsuite';
import RsTooltip from 'components/Rsuite/Tooltip/Tooltip';
import { RsDateRangePicker } from 'components/Rsuite/DateRangePicker';
import { ActionType } from 'core/rtbCampaign/singlePage/common';

interface Iprops {
  errors: FormikErrors<any>;
  values: any;
  minDate: string;
  maxDate: string;
  diffDays: number;
  actionType: string;
  onChange: (startDate: string, endDate: string) => void;
  onChangeStartDate: (date: any) => void;
  onChangeEndDate: (date: any) => void;
}

const FutureDate: React.FC<Iprops> = ({
  values,
  errors,
  minDate,
  maxDate,
  diffDays,
  actionType,
  onChange,
  onChangeStartDate,
  onChangeEndDate,
}) => {
  // 變更廣告期間
  const handleDateRangeChange = (startDate, endDate) => {
    onChange(startDate, endDate);
  };
  const handleChangeStartDate = (date) => {
    onChangeStartDate(date);
  };
  const handleChangeEndDate = (date) => {
    onChangeEndDate(date);
  };

  /* 這邊這樣寫不好, 根本解決方法是在 initialvalues 定義完整型別 */
  const startDate =
    (errors?.basic as { startDate?: string })?.startDate || false;
  const endDate = (errors?.basic as { endDate?: string })?.endDate || false;

  const dataRangeError =
    [startDate, endDate].filter(Boolean).join(' / ') || undefined;

  return (
    <div className='relative float-left'>
      <div>
        <RsDateRangePicker
          startDate={moment(values.basic.startDate).format('YYYY-MM-DD HH:mm')}
          endDate={moment(values.basic.endDate).format('YYYY-MM-DD HH:mm')}
          minDate={moment(minDate).format('YYYY-MM-DD HH:mm')}
          maxDate={moment(maxDate).endOf('day').format('YYYY-MM-DD HH:mm')}
          showTimePicker={true}
          onStartDateChange={handleChangeStartDate}
          onEndDateChange={handleChangeEndDate}
          startDatePickerDisabled={
            actionType === ActionType.EDIT &&
            new Date(values.basic.startDate) <= new Date()
          }
        />
        <>
          <div className='mt-1 flex items-center gap-1'>
            <Form.HelpText>
              建議活動至少大於兩周，以達到系統最佳學習效果
            </Form.HelpText>
            <RsTooltip>
              <span>廣告活動開始後，將無法修改開始日期</span>
            </RsTooltip>
          </div>
          <Form.HelpText>共 {diffDays} 天</Form.HelpText>
        </>
      </div>
      <Form.ErrorMessage show={dataRangeError !== undefined} placement='topEnd'>
        {dataRangeError}
      </Form.ErrorMessage>
    </div>
  );
};

export default FutureDate;
